import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "article-container" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "loading"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }

import { computed, ref, watch } from 'vue'
import { useThemeColor } from '@/utils/theme'
import ArticleCard from './ArticleCard.vue'
import ShortVideo from '@/views/shortVideo/components/ShortVideo.vue'
import { Record } from '@/api/Models/CommunityBoardContentList'
import Error from '@/components/Error.vue'
import { Attachment } from '@/api/Models/Attachment'
import { useI18n } from 'vue-i18n'
import { Sticky } from 'vant'

export default /*@__PURE__*/_defineComponent({
  __name: 'Article',
  props: {
    articleData: {},
    top: {},
    type: {},
    listLoading: { type: Boolean },
    page: {},
    activeType: {},
    errorMsg: {}
  },
  emits: ['showPreview', 'handleScroll', 'handleActive'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v5d12d872": (_unref(themeColor))
}))

const themeColor = useThemeColor()
const { t } = useI18n()

const props = __props
const tabList = computed(() => {
  return props.type === 1
    ? [t('app_all'), t('pc_community_note'), t('pc_community_article'), t('pc_community_album')]
    : [t('newest'), t('hotest')]
})
const active = ref(props.activeType || 0)
const msg = ref(props.errorMsg || t('app_empty'))
const errorImg = ref('')
watch(
  () => props.activeType,
  (newValue) => {
    active.value = newValue || 0
  }
)
watch(
  () => props.errorMsg,
  (newValue) => {
    msg.value = newValue || t('app_empty')
    errorImg.value = newValue ? 'no_permession_part_detail.png' : ''
  },
  { immediate: true }
)
const emits = __emit
const showPreview = (data: { attachments: Attachment[]; index: number }) => {
  emits('showPreview', data)
}

const handleScroll = (info: { isFixed: boolean }) => {
  emits('handleScroll', info.isFixed)
}

const setActiveTab = (index: number) => {
  active.value = index
  emits('handleActive', index)
}

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Sticky), {
      onScroll: handleScroll,
      "offset-top": __props.top
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tab-item", { active: active.value === index }]),
              key: index,
              onClick: ($event: any) => (setActiveTab(index))
            }, [
              _createTextVNode(_toDisplayString(item) + " ", 1),
              _createElementVNode("div", {
                class: _normalizeClass(["line", { active: active.value === index }])
              }, null, 2)
            ], 10, _hoisted_3))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["offset-top"]),
    (__props.page === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (__props.listLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (__props.articleData.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (__props.articleData && __props.articleData.length > 0)
                        ? (_openBlock(), _createBlock(ArticleCard, {
                            key: 0,
                            articleData: __props.articleData,
                            pageType: 0,
                            active: active.value,
                            page: __props.page,
                            onShowPreview: showPreview
                          }, null, 8, ["articleData", "active", "page"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(Error, {
                      key: 1,
                      status: { info: msg.value, imgSrc: errorImg.value },
                      selfStyle: { height: 'auto', width: '100%', marginTop: '20px' }
                    }, null, 8, ["status"]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_van_loading, {
                  size: "24px",
                  vertical: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('loading')), 1)
                  ]),
                  _: 1
                })
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (__props.articleData.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (__props.type === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (__props.articleData && __props.articleData.length > 0)
                        ? (_openBlock(), _createBlock(ArticleCard, {
                            articleData: __props.articleData,
                            key: 0,
                            active: active.value,
                            page: __props.page,
                            onShowPreview: showPreview
                          }, null, 8, ["articleData", "active", "page"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(ShortVideo, {
                      key: 1,
                      articleData: __props.articleData,
                      active: active.value
                    }, null, 8, ["articleData", "active"]))
              ]))
            : (_openBlock(), _createBlock(Error, {
                key: 1,
                status: { info: msg.value, imgSrc: errorImg.value },
                selfStyle: { height: 'auto', width: '100%', marginTop: '20px' }
              }, null, 8, ["status"]))
        ]))
  ]))
}
}

})